import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'currencyFormat'
})
export class CurrencyFormatPipe implements PipeTransform {
  transform(value: any, lang: string): string {
    if (value === null || value === undefined || isNaN(Number(value))) {
      return value;
    }
    
    const amount = Number(value);
    
    if (lang === 'de') {
      // Germany/Swiss German style: 100'000.00
      return new Intl.NumberFormat('de-CH', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      }).format(amount);
    } else {
      // English style: 100,000.00
      return new Intl.NumberFormat('en-US', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      }).format(amount);
    }
  }
}
